/**
 * 백엔드 구성 시, label, msg 여부 파악, prefix 추가 후 Response
 */

export default [
    {
        eventType: "INGEST",
        conditionCustomFields: [
            {
                name: "common::label::Input path",
                key: "inputPath",
                fieldType: "INPUT_FIELD",
                placeholder: "ex> mz-cm-transcoding-input/mz-cm/*",
                required: true,
                maxByte: 255,
            },
        ],
        actions: [
            {
                index: 0,
                key: "/stage/jobs/start-transcoding",
                name: "common::label::Transcode",
                customFields: [
                    {
                        name: "common::label::Pipeline",
                        key: "pipelineId",
                        fieldType: "PIPELINE_SELECT",
                        placeholder: "common::label::Select pipeline",
                        required: true,
                    },
                    {
                        name: "common::label::Save origin asset",
                        key: "isCreateOriginAsset",
                        fieldType: "SWITCH",
                        defaultValue: "false",
                        options: [
                            { label: "Yes", value: "true" },
                            { label: "No", value: "false" },
                        ],
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    inputs: ["{{:jobInput:}}"],
                    jobId: "{{:jobId:}}",
                    projectId: "{{:projectId:}}",
                },
            },
            {
                index: 1,
                key: "/stage/assets/create",
                name: `common::label::Create MP4 asset`,
                customFields: [
                    {
                        name: "common::label::Name",
                        key: "name",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Asset name",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Status",
                        key: "status",
                        fieldType: "SWITCH",
                        defaultValue: "INACTIVE",
                        required: true,
                        options: [
                            { label: "Active", value: "ACTIVE" },
                            { label: "Inactive", value: "INACTIVE" },
                        ],
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    ingestType: "DIRECT",
                    mediaType: "VIDEO",
                    type: "{{:sourceType:}}",
                    type_: "MP4",
                    mimeType: "{{:sourceMimeType:}}",
                    size: "{{:sourceSize:}}",
                    projectId: "{{:projectId:}}",
                    elements: [
                        {
                            urls: ["{{:sourceUrl:}}"],
                            locationType: "S3",
                        },
                    ],
                },
            },
            {
                index: 2,
                key: "/stage/assets/create",
                name: "common::label::Create MP3 asset",
                customFields: [
                    {
                        name: "common::label::Name",
                        key: "name",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Asset name",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Status",
                        key: "status",
                        fieldType: "SWITCH",
                        defaultValue: "INACTIVE",
                        required: true,
                        options: [
                            { label: "Active", value: "ACTIVE" },
                            { label: "Inactive", value: "INACTIVE" },
                        ],
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    ingestType: "DIRECT",
                    mediaType: "AUDIO",
                    type: "{{:sourceType:}}",
                    type_: "MP3",
                    mimeType: "{{:sourceMimeType:}}",
                    size: "{{:sourceSize:}}",
                    projectId: "{{:projectId:}}",
                    elements: [
                        {
                            urls: ["{{:sourceUrl:}}"],
                            locationType: "S3",
                        },
                    ],
                },
            },
            {
                index: 3,
                key: "/stage/assets/create",
                name: `common::label::Create IMAGE asset`,
                customFields: [
                    {
                        name: "common::label::Name",
                        key: "name",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Asset name",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Status",
                        key: "status",
                        fieldType: "SWITCH",
                        defaultValue: "INACTIVE",
                        required: true,
                        options: [
                            { label: "Active", value: "ACTIVE" },
                            { label: "Inactive", value: "INACTIVE" },
                        ],
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    ingestType: "DIRECT",
                    mediaType: "IMAGE",
                    type: "IMAGE",
                    type_: "IMAGE",
                    mimeType: "{{:sourceMimeType:}}",
                    size: "{{:sourceSize:}}",
                    projectId: "{{:projectId:}}",
                    elements: [
                        {
                            url: "{{:sourceUrl:}}",
                            locationType: "S3",
                        },
                    ],
                },
            },
            {
                index: 4,
                key: "/stage/assets/create",
                name: `common::label::Create CAPTION asset`,
                customFields: [
                    {
                        name: "common::label::Name",
                        key: "name",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Asset name",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Status",
                        key: "status",
                        fieldType: "SWITCH",
                        defaultValue: "INACTIVE",
                        required: true,
                        options: [
                            { label: "Active", value: "ACTIVE" },
                            { label: "Inactive", value: "INACTIVE" },
                        ],
                    },
                    {
                        name: "common::label::Kind",
                        key: "kind",
                        fieldType: "SINGLE_SELECT",
                        placeholder: "common::label::Select kind",
                        required: true,
                        options: [
                            { label: "common::label::Caption", value: "CAPTION" },
                            { label: "common::label::Subtitle", value: "SUBTITLE" },
                            { label: "common::label::Description", value: "DESCRIPTION" },
                            { label: "common::label::Chapter", value: "CHAPTER" },
                            { label: "common::label::Metadata", value: "METADATA" },
                        ],
                    },
                    {
                        name: "common::label::Label",
                        key: "label",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Caption label",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Language",
                        key: "language-country",
                        fieldType: "CAPTION_LANGUAGE_SELECT",
                        placeholder: "common::label::Select language",
                        required: true,
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    ingestType: "DIRECT",
                    mediaType: "CAPTION",
                    type: "${kind}",
                    type_: "CAPTION",
                    mimeType: "text/vtt",
                    size: "{{:sourceSize:}}",
                    projectId: "{{:projectId:}}",
                    elements: [
                        {
                            label: "${label}",
                            kind: "${kind}",
                            language: "${language}",
                            country: "${country}",
                            url: "{{:sourceUrl:}}",
                            locationType: "S3",
                        },
                    ],
                },
            },
            {
                index: 5,
                key: "/stage/assets/create",
                name: `common::label::Create FILE asset`,
                customFields: [
                    {
                        name: "common::label::Name",
                        key: "name",
                        fieldType: "INPUT_FIELD",
                        placeholder: "common::label::Asset name",
                        required: true,
                        maxByte: 255,
                    },
                    {
                        name: "common::label::Status",
                        key: "status",
                        fieldType: "SWITCH",
                        defaultValue: "INACTIVE",
                        required: true,
                        options: [
                            { label: "Active", value: "ACTIVE" },
                            { label: "Inactive", value: "INACTIVE" },
                        ],
                    },
                    {
                        name: "common::label::Categories",
                        key: "categories",
                        fieldType: "CATEGORY_SELECT_AREA",
                        categoryType: "Asset",
                    },
                    {
                        name: "common::label::Tags",
                        key: "tags",
                        fieldType: "HASHTAG_INPUT_AREA",
                    },
                ],
                automaticValues: {
                    ingestType: "DIRECT",
                    mediaType: "FILE",
                    type: "FILE",
                    type_: "FILE",
                    mimeType: "{{:sourceMimeType:}}",
                    size: "{{:sourceSize:}}",
                    projectId: "{{:projectId:}}",
                    elements: [
                        {
                            url: "{{:sourceUrl:}}",
                            locationType: "S3",
                        },
                    ],
                },
            },
        ],
    },
];
